/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactType
 */
export interface ContactType {
}

/**
 * Check if a given object implements the ContactType interface.
 */
export function instanceOfContactType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactTypeFromJSON(json: any): ContactType {
    return ContactTypeFromJSONTyped(json, false);
}

export function ContactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactType {
    return json;
}

export function ContactTypeToJSON(value?: ContactType | null): any {
    return value;
}

